import { useEffect, useState } from 'react'
import { Card, Grid, TextField, Container, Typography, MenuItem } from '@mui/material'
import { makeStyles } from '@material-ui/core'
import MessageError from '../../../messages/messageError'
import api from '../../../services/api'
import { useSelector } from 'react-redux'
import MessageSuccess from '../../../messages/messageSuccess'
import HeaderGestorConfigs from '../../../utils/headerGestorConfigs'
import ButtonLeft from '../../../utils/buttonLeft'
import Loading from '../../../load/loading'


const useStyles = makeStyles((theme) => ({
    root: {
        alignItems: 'end',
    },

    gridItem: {
        padding: 5,
        // background: 'red'
    },
}))

export default function CreatePerfil() {
    const classes = useStyles()
    const [perfil, setperfil] = useState('')
    const [perfils, setperfils] = useState('')
    const [seccoes, setSeccoes] = useState([])
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setErrorMessage] = useState('')
    const [load, setLoad] = useState(false)
    const user = useSelector(state => state.account.user);

    useEffect(() => {
        api.get('/perfils')
            .then(res => {
                // console.log(res)
                setperfils(res.data.perfils);
            }).catch(err => '')

        api.get('/seccoes')
            .then(res => {
                // console.log(res)
                setSeccoes(res.data.seccoes);
            }).catch(err => '')

    }, [messageSuccess])


    function HandleChange(e) {
        setperfil({ ...perfil, [e.target.name]: e.target.value })
    }

    async function createAdmin() {

        setLoad(true)
        setErrorMessage('')
        setMessageSuccess('')

        await api.post('/perfil/create', { ...perfil, userId: user?._id })
            .then(res => {
                // console.log(res)
                setLoad(false)
                setMessageSuccess(res.data.msg)

            }).catch(error => {
                // console.log(error)
                setErrorMessage(error.response.data.message)
                setLoad(false)
            })
    }

    return (
        <Container>
            <Card style={{ padding: 20, marginBottom: 20 }}>

                {messageSuccess && <MessageSuccess message={messageSuccess} />}
                {messageError && < MessageError message={messageError} />}

                {perfils ?
                    <div style={{ marginBottom: 50 }}>
                        <HeaderGestorConfigs title='PERFILS:' />
                        {perfils.map((perfil) => (
                            <Typography key={perfil._id} >
                                <b> {perfil.designacao} </b>
                            </Typography>
                        ))}
                    </div>
                    :
                    <Loading text={'A carregar perfils'} />
                }

                <Grid container className={classes.root}>
                    <Grid Grid xs={12} md item className={classes.gridItem}>
                        <TextField
                            style={{ marginTop: 15 }}
                            type="text"
                            required
                            label="Designação"
                            fullWidth
                            size="small"
                            name="designacao"
                            variant="outlined"
                            onChange={HandleChange}
                            defaultValue={perfil?.designacao}
                        />
                    </Grid>

                    <Grid Grid xs={12} md item className={classes.gridItem}>
                        <TextField
                            style={{ marginTop: 15 }}
                            type="text"
                            required
                            label="Perfil"
                            fullWidth
                            size="small"
                            name="perfil"
                            variant="outlined"
                            onChange={HandleChange}
                            defaultValue={perfil?.perfil}
                        />
                    </Grid>

                    <Grid xs={12} md item className={classes.gridItem}>
                        <TextField
                            style={{ marginTop: 15 }}
                            type="text"
                            select
                            required
                            label="Secção"
                            fullWidth
                            size="small"
                            name="seccao"
                            variant="outlined"
                            onChange={HandleChange}
                            defaultValue={perfil?.seccao}
                        >

                            {seccoes.map((seccao) => (
                                <MenuItem key={seccao?._id} value={seccao?.designacao}>
                                    {seccao?.designacao}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>

                <ButtonLeft
                    title={'Criar'}
                    load={load}
                    disabled={!perfil?.designacao}
                    funcao={createAdmin}
                />

            </Card>
        </Container>
    )
}
